module.exports = __webpack_public_path__ + "static/media/Mentorship-6.ed84fa0e.jpg";